module.exports = __webpack_public_path__ + "static/media/cross-red.b2faf2e4.svg";